import { css } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function Keys({ v }) {
  if (!v.showKeys) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.closeKeys}>
        <div className="gp-venster gp-vast" style={{ "width": "min(700px,100%)", "maxHeight": "calc(100vh - 80px)", "overflow": "hidden", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "18px", "boxSizing": "border-box" }} onClick={v.stopProp}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px", "flex": "0 0 auto" }}>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "3px", "flex": "1 1 auto", "minWidth": "0" }}>
              <div style={{ "fontSize": "19px", "fontWeight": "700", "lineHeight": "1.2" }}>
                Sneltoetsen
              </div>
            </div>
            <button onClick={v.closeKeys} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={22} />
            </button>
          </div>
          <div className="gp-toetsen" style={{ "display": "grid", "gridTemplateColumns": "repeat(3,1fr)", "gap": "24px", "flex": "1 1 auto", "minHeight": "0", "overflowY": "auto", "alignContent": "start" }}>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "9px", "minWidth": "0" }}>
              <div style={{ "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-3)", "lineHeight": "1.2" }}>
                Gereedschap
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  B
                </span>
                <span style={{ "minWidth": "0" }}>
                  Potlood
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  E
                </span>
                <span style={{ "minWidth": "0" }}>
                  Gum
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  G
                </span>
                <span style={{ "minWidth": "0" }}>
                  Vulemmer
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  S
                </span>
                <span style={{ "minWidth": "0" }}>
                  Spray
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  P
                </span>
                <span style={{ "minWidth": "0" }}>
                  Volgende vorm
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  /
                </span>
                <span style={{ "minWidth": "0" }}>
                  Lijn
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  R
                </span>
                <span style={{ "minWidth": "0" }}>
                  Rechthoek
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  O
                </span>
                <span style={{ "minWidth": "0" }}>
                  Cirkel
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  I
                </span>
                <span style={{ "minWidth": "0" }}>
                  Hulplijnen aan of uit
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  + −
                </span>
                <span style={{ "minWidth": "0" }}>
                  Dikker of dunner
                </span>
              </div>
            </div>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "9px", "minWidth": "0" }}>
              <div style={{ "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-3)", "lineHeight": "1.2" }}>
                Selectie
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  M
                </span>
                <span style={{ "minWidth": "0" }}>
                  Kader
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  L
                </span>
                <span style={{ "minWidth": "0" }}>
                  Lasso
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  ⌘A
                </span>
                <span style={{ "minWidth": "0" }}>
                  Alles selecteren
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  Esc
                </span>
                <span style={{ "minWidth": "0" }}>
                  Selectie laten gaan
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  ↑↓←→
                </span>
                <span style={{ "minWidth": "0" }}>
                  1 pixel opschuiven
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  ⇧ + pijl
                </span>
                <span style={{ "minWidth": "0" }}>
                  8 pixels opschuiven
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  H
                </span>
                <span style={{ "minWidth": "0" }}>
                  Spiegelen
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  ⇧H
                </span>
                <span style={{ "minWidth": "0" }}>
                  Op z'n kop zetten
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  ⌘C ⌘V
                </span>
                <span style={{ "minWidth": "0" }}>
                  Kopiëren en plakken
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  ⌘X
                </span>
                <span style={{ "minWidth": "0" }}>
                  Knippen
                </span>
              </div>
            </div>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "9px", "minWidth": "0" }}>
              <div style={{ "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-3)", "lineHeight": "1.2" }}>
                Kleuren
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  1–8
                </span>
                <span style={{ "minWidth": "0" }}>
                  Kleur kiezen
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  X
                </span>
                <span style={{ "minWidth": "0" }}>
                  Vorige kleur terug
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  Backspace
                </span>
                <span style={{ "minWidth": "0" }}>
                  Kleur uit je selectie
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  Dubbelklik
                </span>
                <span style={{ "minWidth": "0" }}>
                  Alles van één kleur
                </span>
              </div>
              <div style={{ "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-3)", "lineHeight": "1.2", "marginTop": "9px" }}>
                Beelden
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  Spatie
                </span>
                <span style={{ "minWidth": "0" }}>
                  Afspelen of stoppen
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  ← →
                </span>
                <span style={{ "minWidth": "0" }}>
                  Vorig of volgend beeld
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  ⌘Z
                </span>
                <span style={{ "minWidth": "0" }}>
                  Ongedaan maken
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  ⌘⇧Z
                </span>
                <span style={{ "minWidth": "0" }}>
                  Opnieuw
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  Spatie +
                </span>
                <span style={{ "minWidth": "0" }}>
                  Vorm slepend verplaatsen
                </span>
              </div>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.2" }}>
                <span style={{ "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "26px", "height": "24px", "padding": "0 7px", "boxSizing": "border-box", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "var(--lila)", "fontSize": "11px", "fontWeight": "700", "flex": "0 0 auto" }}>
                  ⇧ +
                </span>
                <span style={{ "minWidth": "0" }}>
                  Vorm recht, vierkant of rond
                </span>
              </div>
            </div>
          </div>
          <button onClick={v.closeKeys} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
            Klaar
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
